import { generatePath } from "react-router-dom";

import { ROUTE_PATH } from "src/core/constants/routePath";

export const tenantPaths = {
  home: (tenantId: string) => generatePath(ROUTE_PATH.HOME, { tenantId }),
  folders: (tenantId: string) => generatePath(ROUTE_PATH.FOLDERS, { tenantId }),
  folder: (tenantId: string, id: string) => generatePath(ROUTE_PATH.FOLDER, { tenantId, id }),
  import: (tenantId: string) => generatePath(ROUTE_PATH.IMPORT, { tenantId }),

  // Routes d'erreur tenant-scoped
  error403: (tenantId: string) => generatePath(ROUTE_PATH.TENANT_ERROR_403, { tenantId }),
  error404: (tenantId: string) => generatePath(ROUTE_PATH.TENANT_ERROR_404, { tenantId }),
  error500: (tenantId: string) => generatePath(ROUTE_PATH.TENANT_ERROR_500, { tenantId }),
};
